import React from "react";
import { useNavigate } from "react-router-dom";
import { SERVICES } from "../../data/services";
import { CONTACT } from "../../data/constants";
import CTA from "../CTA/CTA";
import "./Footer.css";
import { useTranslation } from "react-i18next";

function Footer() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <CTA />

      <div className="footer__body container">
        {/* Brand */}
        <div className="footer__col">
          <div className="footer__logo">
            <div className="footer__logo-mark">
              <img src="/sk.png" alt="SK Associate" className="footer__logo-img" />
            </div>
            <span className="footer__brand">SK ASSOCIATE</span>
          </div>
          <p className="footer__about">
            {t("footer.about")}
          </p>
          <p className="footer__gst">{t("footer.gst")}</p>
        </div>

        {/* Services */}
        <div className="footer__col">
          <p className="footer__col-title">{t("footer.services_title")}</p>
          {SERVICES.map((s) => (
            <div key={s.id} className="footer__link" onClick={() => navigate(`/services/${s.id}`)}>
              → {t(`services_data.${s.id}.title`, s.title)}
            </div>
          ))}
        </div>

        {/* Quick links */}
        <div className="footer__col">
          <p className="footer__col-title">{t("footer.quick_links_title")}</p>
          {[
            ["/",         t("footer.quick_links.home")],
            ["/about",    t("footer.quick_links.about")],
            ["/services", t("footer.quick_links.services")],
            ["/projects", t("footer.quick_links.projects")],
            ["/contact",  t("footer.quick_links.contact")],
          ].map(([path, label]) => (
            <div key={path} className="footer__link" onClick={() => navigate(path)}>
              → {label}
            </div>
          ))}
        </div>

        {/* Contact */}
        <div className="footer__col">
          <p className="footer__col-title">{t("footer.contact_title")}</p>
          <div className="footer__contact-text">
            <p>📍 {CONTACT.address1}</p>
            <p>{CONTACT.address2}</p>
            <br />
            {CONTACT.phones.map((p) => <p key={p}>📞 {p}</p>)}
            <br />
            {CONTACT.emails.map((e) => <p key={e}>✉ {e}</p>)}
            <p>🌐 {CONTACT.website}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
